import React from 'react';
import PropTypes from 'prop-types';
import {
  Text,
  Flex,
  Modal,
  Button,
  HStack,
  Divider,
  Spinner,
  ModalBody,
  ModalHeader,
  ModalContent,
  ModalOverlay,
  ModalCloseButton,
} from 'ui';
import {
  SelectField,
  RadioButton,
  RadioButtonField,
} from '@components/Form/Field';
import { style as s } from './WorkFormModal.style';
import { ts } from './utils';
import { useController } from './hooks';

export const WorkFormModal = (props) => {
  const { isOpen, onClose, onCompleted } = props;

  const {
    control,
    loading,
    onSubmit,
    isSubmitting,
    employmentName,
    workingSectorOptions,
    workingActivitiesOptions,
  } = useController({ onCompleted, onClose });

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{ts('title')}</ModalHeader>
        <Divider />
        <ModalCloseButton />
        <ModalBody>
          {loading && (
            <Flex {...s.center}>
              <Spinner color="gray.500" />
            </Flex>
          )}
          {!loading && (
            <Flex {...s.container}>
              <Text {...s.employmentName}>
                {ts('occupation', { occupation: employmentName })}
              </Text>
              <RadioButtonField
                variant="wrap"
                name="workingSectorId"
                data-testid="sectorField"
                control={control}
                labelText={ts('sectorLabel')}
              >
                {workingSectorOptions?.map((workingSector) => (
                  <RadioButton value={workingSector.id} key={workingSector.id}>
                    {workingSector.label}
                  </RadioButton>
                ))}
              </RadioButtonField>
              <SelectField
                name="workingActivityId"
                control={control}
                data-testid="activityField"
                labelText={ts('workActivityLabel')}
                placeholder={ts('placeholder')}
              >
                {workingActivitiesOptions?.map((workingActivity) => (
                  <option key={workingActivity.id} value={workingActivity.id}>
                    {workingActivity.label}
                  </option>
                ))}
              </SelectField>
              <HStack>
                <Button
                  {...s.buttons}
                  onClick={onClose}
                  variant="ghost"
                >
                  {ts('cancel')}
                </Button>
                <Button
                  {...s.buttons}
                  onClick={onSubmit}
                  isDisabled={isSubmitting}
                >
                  {ts('save')}
                </Button>
              </HStack>
            </Flex>
          )}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

WorkFormModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onCompleted: PropTypes.func,
};

WorkFormModal.defaultProps = {
  onCompleted: () => { },
};
